// src/components/QueryInput/mimeTypeToLanguage.js
export const mimeTypeToLanguage = (mimeType) => {
  const mimeMap = {
    'application/javascript': 'javascript',
    'text/javascript': 'javascript',
    'text/html': 'html',
    'text/css': 'css',
    'application/json': 'json',
    'text/plain': 'plaintext',
    'text/x-python': 'python', // Added Python
    'text/x-java-source': 'java', // Added Java
    'text/x-c++src': 'cpp', // Added C++
    // Add more mappings as needed
  };
  return mimeMap[mimeType] || 'plaintext';
};
